import type { ConsultationSourceEnumType } from '@forgd/contract/types'
import { AnalyticsEventEnum, ProductToolIdSchema } from '@forgd/contract/types'

export function useConsultationTracking() {
  const route = useRoute()
  const { destination } = useConsultationDestination()
  const { capture } = useAnalytics()

  function captureConsultationClick(source: ConsultationSourceEnumType, url?: string) {
    const targetUrl = destination.value.to

    if (url !== undefined && url !== targetUrl) {
      return
    }

    const toolResult = ProductToolIdSchema.safeParse(route.meta.productTool)

    const subTool = typeof route.meta.productSubTool === 'string'
      ? route.meta.productSubTool
      : undefined

    capture(AnalyticsEventEnum.ScheduleConsultationClicked, {
      path: route.fullPath,
      source,
      target_url: targetUrl,
      ...(toolResult.success ? { product_tool: toolResult.data } : {}),
      ...(subTool ? { product_sub_tool: subTool } : {}),
    })
  }

  return { captureConsultationClick }
}
